import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthService } from './services/auth.service';
import { NetworkService } from './services/network.service';
import { PwaUpdateService } from './services/pwa-update.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  exports: [],
  providers: [AuthService, NetworkService, PwaUpdateService]
})
export class SharedModule { }
